import { createContext } from "react";

export const themes = {
  dark: "white-content",
  light: "",
};

export const ThemeContext = createContext({
  theme: themes.dark,
  changeTheme: () => {},
});
